import React, { useEffect, useRef, useState } from 'react';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';

interface PlayerOptions {
    controls?: boolean;
    autoplay?: boolean;
    responsive?: boolean;
    fluid?: boolean;
    sources?: {
        src: string;
        type: string;
    }[];
}

interface VideoPlayerProps {
    options: PlayerOptions;
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ options }) => {
    const videoRef = useRef<HTMLVideoElement | null>(null);
    const playerRef = useRef<any | null>(null);
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        if (isMounted && videoRef.current && !playerRef.current) {
            playerRef.current = videojs(videoRef.current, options);
        }

        return () => {
            if (playerRef.current) {
                playerRef.current.dispose();
                playerRef.current = null;
            }
        };
    }, [isMounted, options]);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    return (
        <div data-vjs-player>
            {isMounted && <video ref={videoRef} className="video-js vjs-big-play-centered" />}
        </div>
    );
};

export default VideoPlayer;
